// API base URL.
// - Local dev / same-server deploy: leave REACT_APP_API_URL unset → "" (relative, same origin)
// - Cloudflare Pages (frontend separate from backend): set REACT_APP_API_URL to the API domain,
//   e.g. https://api.earnixglobal.com
const API = process.env.REACT_APP_API_URL || "";
export default API;
